import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { SetUserContext } from '../../context api/UserContext'

import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useAuthentication = (handleNext) => {
  const history = useHistory()
  const [otpVerified, setOtpVerified] = useState(false)
  const [key, setKey] = useState('')
  const [otpSent, setOtpSent] = useState(false)
  const setUser = useContext(SetUserContext)
  const [loading, setLoading] = useState(false)
  const [fileUrl, setFileUrl] = useState(false)

  const setUserContext = (data)=>{
    const tempUser = data.user
    const user = {
      _id: tempUser._id,
      name: tempUser.firstName,
      userType: tempUser.userType,
      profilePicture: tempUser.profilePicture,
      allowedFeatures: tempUser.userType === "COMPANYADMIN"?
      tempUser.subscription?.modules && tempUser.subscription?.modules ? tempUser.subscription?.modules : []:
      tempUser.permissions && tempUser.permissions.allowed ? tempUser.permissions.allowed : [],
      position: tempUser.userType === 'ALLEMPLOYEE' ? tempUser.position && tempUser.position.positionName : tempUser.userType,
      loginTime: Date.now(),
      email: tempUser.email,
      phoneNumber: tempUser.phoneNumber,
      firstTimeLoggedIn: tempUser.userType === 'ALLEMPLOYEE' ? tempUser.firstTimeLoggedIn : false,
      companyAdminId: tempUser.companyAdminId?._id,
    }
    console.log(user)
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('token', JSON.stringify(data.token))
    data.user.userType !== 'SUPERADMIN' && localStorage.setItem('company', JSON.stringify(tempUser.userType !== 'COMPANYADMIN' ? tempUser.companyAdminId : data.company))
    setUser({
      token: data.token,
      user: user,
      company: data.user.userType !== 'SUPERADMIN' && data.company,
    })
    // data.user.userType === 'SUPERADMIN' && history.push(ROUTES.ALL_COMPANIES)
    // data.user.userType !== 'SUPERADMIN' && history.push(ROUTES.DASHBOARD)
  }
  const loginUser = (dto) => {
    setLoading(true)
    axios
      .post(API.LOGIN, dto)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('User Not Found', error)
        }
        console.log('DATA : ', data.user)
        const tempUser = data.user
        const user = {
          _id: tempUser._id,
          name: tempUser.firstName,
          userType: tempUser.userType,
          profilePicture: tempUser.profilePicture,
          allowedFeatures: tempUser.userType === "COMPANYADMIN"?
          tempUser.companyPermissions && tempUser.companyPermissions.allowed ? tempUser.companyPermissions.allowed : []:
          tempUser.permissions && tempUser.permissions.allowed ? tempUser.permissions.allowed : [],
          position: tempUser.userType === 'ALLEMPLOYEE' ? tempUser.position && tempUser.position.positionName : tempUser.userType,
          loginTime: Date.now(),
          email: tempUser.email,
          phoneNumber: tempUser.phoneNumber,
          firstTimeLoggedIn: tempUser.userType === 'ALLEMPLOYEE' ? tempUser.firstTimeLoggedIn : false,
          companyAdminId: tempUser.companyAdminId?._id,
          companyPermissions  :tempUser.companyPermissions,
        }
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('token', JSON.stringify(data.token))
        data.user.userType !== 'SUPERADMIN' && localStorage.setItem('company', JSON.stringify(tempUser.userType !== 'COMPANYADMIN' ? tempUser.companyAdminId : data.company))
        setUser({
          token: data.token,
          user: user,
          company: data.user.userType !== 'SUPERADMIN' && data.company,
        })
        data.user.userType === 'SUPERADMIN' && history.push(ROUTES.ALL_COMPANIES)
        data.user.userType !== 'SUPERADMIN' && history.push(ROUTES.DASHBOARD)
        return toastMessage('Logged In', success)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const signupUser = (dto, handleNext= ()=>{}) => {
    setLoading(true)
    axios
      .post(API.SIGNUP, dto)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('User Not Found', error)
        }
        // loginUser(data.user)
        toastMessage('Company Admin Created Successfully', success)
        setUserContext(data)
        handleNext();
        // history.push(ROUTES.HOME)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const sendOtpOnEmail = (dto) => {
    setLoading(true)
    //console.log('DTO : ', dto)

    axios
      .post(API.SEND_OTP_EMAIL, dto)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        // //console.log('SET KEY FUNCTION : ', setKey(data))
        // //console.log(data.sId)
        setOtpSent(true)

        toastMessage(`Email Otp Sent Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const sendOtp = (dto) => {
    setLoading(true)
    axios
      .post(API.SEND_OTP_MOBILE, dto)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        // //console.log('SET KEY FUNCTION : ', setKey(data))
        //console.log(data.sId)
        setOtpSent(true)
        setKey(data.sId)
        //console.log('KEY : ', key)
        localStorage.setItem('sId', data.sId)
        toastMessage(`Mobile Otp Sent Successfully`, success)
        handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const resetPassword = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .post(API.RESET_PASSWORD, dto)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        // //console.log('SET KEY FUNCTION : ', setKey(data))
        //console.log(data.sId)
        setOtpSent(true)
        setKey(data.sId)
        //console.log('KEY : ', key)
        localStorage.setItem('sId', data.sId)
        toastMessage(`Otp Sent Successfully`, success)
        handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const verifyOtp = (dto) => {
    setLoading(true)
    axios
      .post(API.VERIFY_OTP_MOBILE, dto)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }

        setOtpVerified(true)
        toastMessage(`Mobile Otp Verified Successfully`, success)
        // handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const verifyOtpOnEmail = (dto) => {
    setLoading(true)
    axios
      .post(API.VERIFY_OTP_EMAIL, dto)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }

        setOtpVerified(true)
        toastMessage(`Email Otp Verified Successfully`, success)
        handleNext()

        // history.push(ROUTES.HOME)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const updatePassword = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .put(API.UPDATE_PASSWORD, dto)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        history.push(ROUTES.DASHBOARD)
        return toastMessage(`Password Updated Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const acceptPolicy = (dto) => {
    setLoading(true)
    axios
      .put(API.ACCEPT_POLICY, dto)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        // toastMessage(`Policy Accepted Successfully`, success)
        const user = {
          _id: data.data._id,
          name: data.data.firstName,
          userType: data.data.userType,
          profilePicture: data.data.profilePicture,
          alllowedFeatures: data.data.allowedFeatures,
          position: data.data.userType === 'ALLEMPLOYEE' ? data.data.position && data.data.position.positionName : 'Company Admin',
          loginTime: Date.now(),
          email: data.data.email,
          phoneNumber: data.data.phoneNumber,
          firstTimeLoggedIn: data.data.userType === 'ALLEMPLOYEE' ? data.data.firstTimeLoggedIn : false,
          companyAdminId: data.data.companyAdminId,
        }
        //console.log('USER : ', user)
        localStorage.setItem('user', JSON.stringify({ ...user, firstTimeLoggedIn: false }))
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const fileUpload = async (dto) => {
    setLoading(true)
    await axios
      .post(API.UPLOAD_FILE, dto)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('SOmething Went Wrong..!', error)
        }
        setFileUrl(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    loginUser,
    signupUser,
    sendOtp,
    key,
    otpVerified,
    verifyOtp,
    setOtpVerified,
    otpSent,
    verifyOtpOnEmail,
    sendOtpOnEmail,
    updatePassword,
    resetPassword,
    loading,
    acceptPolicy,
    fileUpload,
    fileUrl,
  }
}